import Loader from "components/Loader/Loader";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { IResourceInspection } from "../domain/IResourceInspection";
import {
  getBasicDataForInspectionsOfResources,
  selectState,
} from "../slices/dtRegistration.slice";
import InfoTooltip from "components/Popup/InfoTooltip";
import { unitNameLabel } from "Dashboard/scenes/Resources/helpers/resourceUtil";
import { FormatNumberOrNull, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { FormatDateShort } from "utils/dateUtils";
import { inspectionTypeDictionary } from "utils/translationDictionary";

export const RegistrationPreview = () => {
  const { resourcesInspections, loading } = useSelector(selectState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getBasicDataForInspectionsOfResources());
  }, [dispatch]);

  return (
    <div className="daily-table-inspections loading-container">
      {loading && <Loader />}
      <div className="classicHeader bolded">REGISTRACIJE &nbsp; TAHOGRAFI</div>
      <div className="previewBody">
        {resourcesInspections.map((registration: IResourceInspection) => (
          <div className="singleRegistration">
            <InfoTooltip
              tooltip={registration.resourceName}
              classesProp="daily-table-resource-inspections-name text-overflow"
              element="span"
            >
              {registration.resourceName}
            </InfoTooltip>
            <span className="daily-table-resource-inspections-usage">{FormatNumberOrNull(registration.usageAmount)}</span>
            <span className="daily-table-resource-inspections-unit">{unitNameLabel(registration.usageUnit)}</span>
            <span className="daily-table-resource-inspections-price">{FormatNumberWithUnitOrNull(registration.price, 'rsd')}</span>
            <span className="daily-table-resource-inspections-price-label">cena</span>
            <span className="daily-table-resource-inspections-date">{FormatDateShort(registration.date)}</span>
            <InfoTooltip
              tooltip={inspectionTypeDictionary[registration.type]}
              classesProp="daily-table-resource-inspections-type text-overflow"
              element="span">
              {inspectionTypeDictionary[registration.type]}
            </InfoTooltip>
            <span className="daily-table-resource-inspections-note">{registration.note}</span>
          </div>
        ))}
        {resourcesInspections.length < 3 && (
          <div className="singleRegistration"></div>
        )}
        {resourcesInspections.length < 2 && (
          <div className="singleRegistration"></div>
        )}
        {resourcesInspections.length < 1 && (
          <div className="singleRegistration"></div>
        )}
      </div>
    </div>
  );
};
